import { useState, useEffect, useContext } from 'react';
import { Box, Stack, Paper, Table, TableBody, TableContainer, TableHead, TableRow } from '@mui/material';
import StyledTableRow from '../shared/components/styledTableRow';
import StyledTableCell from '../shared/components/styledTableCell';
import EmployeeMenuPopup from './employeeMenuPopup';
import EmployeeHeader from './employeeHeader';
import ConfirmDialog from '../shared/components/confirmDialog';
import { HomeContext } from '../utils/contexts/homeContext';
import { EmployeeSearchAPIUrl, EmployeeAPIUrl } from '../utils/extensions/functionEx';
import { EmployeeStatus } from '../utils/extensions/constantEx';
import PageLoading from '../shared/components/backdrop';
import { useCookies } from 'react-cookie';

const EmployeeSearch = (props) => {

    const { ShowAPIError, OpenErrorAlert, OpenSuccessAlert, SetEmployeeSearchText, homeState, ClearLoggedUser } = useContext(HomeContext);

    const [dbEmployees, setBbEmployees] = useState([]);
    const [isOpenPageLoad, setIsOpenPageLoad] = useState(false);
    const [isDeleteConfirmOpen, setIsDeleteConfirmOpen] = useState(false);
    const [selectedEmpId, setSelectedEmpId] = useState(0);

    const [cookies, setCookie] = useCookies(['hplus_home_care_user_session_code']);

    useEffect(() => {
        async function fetchEmployees() {
            searchEmployees(homeState.employeeSearchText.length > 0 ? homeState.employeeSearchText : '');
        }
        fetchEmployees();
    }, []);

    const searchEmployees = async (searchText) => {
        try {
            setIsOpenPageLoad(true);
            SetEmployeeSearchText(searchText);

            let tempEmpJson = [];

            const headers = new Headers();
            headers.append("Hc-App-Auth-Token", cookies.hplus_home_care_user_session_code);
            const response = await fetch(EmployeeSearchAPIUrl(homeState.loggedUser.companyCode, searchText), {
                method: "GET",
                headers: headers
            });
            if (response.status === 401) {
                OpenErrorAlert('User login history expired, please log in again.');
                setCookie('hplus_home_care_user_session_code', '', { path: '/' });
                ClearLoggedUser();
            } else if (response.status === 200) {
                tempEmpJson = await response.json();
            } else {
                ShowAPIError(response)
            }
            setBbEmployees([...tempEmpJson]);
        }
        catch (error) {
            OpenErrorAlert(error)
        } finally {
            setIsOpenPageLoad(false);
        }
    }

    const handleEmployeeSearchClick = async (searchText) => {
        await searchEmployees(searchText.trim());
    }

    const handlePageLoadingClose = () => {
        setIsOpenPageLoad(false);
    }

    const handleDeleteClick = (nurseId) => {
        setIsDeleteConfirmOpen(true);
        setSelectedEmpId(nurseId);
    }

    const handleDeleteCancelClick = () => {
        setIsDeleteConfirmOpen(false);
        setSelectedEmpId(0);
    }

    const handleDeleteOKClick = async () => {
        try {
            setIsOpenPageLoad(true);
            setIsDeleteConfirmOpen(false);

            const headers = new Headers();
            headers.append("Accept", "application/json");
            headers.append("Accept-Encoding", "application/json");
            headers.append("Content-Type", "application/json");
            headers.append("Hc-App-Auth-Token", cookies.hplus_home_care_user_session_code);
            const response = await fetch(EmployeeAPIUrl(homeState.loggedUser.companyCode), {
                method: "DELETE",
                headers: headers,
                body: JSON.stringify({ 'id': selectedEmpId })
            });
            if (response.status === 401) {
                OpenErrorAlert('User login history expired, please log in again.');
                setCookie('hplus_home_care_user_session_code', '', { path: '/' });
                ClearLoggedUser();
            } else if (response.status === 200) {
                OpenSuccessAlert('Employee details successfully deleted.');
                await searchEmployees(homeState.employeeSearchText.length > 0 ? homeState.employeeSearchText : '');
            } else {
                ShowAPIError(response);
            }
        }
        catch (error) {
            OpenErrorAlert(error)
        } finally {
            setIsOpenPageLoad(false);
            setSelectedEmpId(0);
        }
    }

    return (
        <Box sx={{ bgcolor: '#cfe8fc', padding: '8px, 0' }}>
            <Stack spacing={0}>
                {
                    isOpenPageLoad &&
                    <PageLoading isOpenPageLoading={isOpenPageLoad} handleClose={handlePageLoadingClose} />
                }
                {
                    isDeleteConfirmOpen &&
                    <ConfirmDialog isOpen={isDeleteConfirmOpen} title="Confirm Delete"
                        message="Are you sure you want to delete the employee?"
                        handleClickOK={handleDeleteOKClick}
                        handleClickCancel={handleDeleteCancelClick} />

                }
                <EmployeeHeader handleEmpSearchClick={handleEmployeeSearchClick} />
                <TableContainer component={Paper} sx={{ maxHeight: '79vh', borderRadius: '0' }}>
                    <Table stickyHeader sx={{ minWidth: 700 }}>
                        <TableHead>
                            <TableRow>
                                <StyledTableCell align="center" sx={{ width: '55px' }}></StyledTableCell>
                                <StyledTableCell sx={{ width: '220px' }}>Code</StyledTableCell>
                                <StyledTableCell>Name</StyledTableCell>
                                <StyledTableCell sx={{ width: '650px' }}>Phone Nos</StyledTableCell>
                                <StyledTableCell sx={{ width: '150px' }}>Status</StyledTableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {dbEmployees.map((row) => (
                                <StyledTableRow key={row.id.toString()}>
                                    <StyledTableCell align="center">
                                        <EmployeeMenuPopup dbEmployeeRow={row} handleDeleteClick={handleDeleteClick} />
                                    </StyledTableCell>
                                    <StyledTableCell>
                                        {row.code}
                                    </StyledTableCell>
                                    <StyledTableCell>{row.employee_name}</StyledTableCell>
                                    <StyledTableCell>{row.phone}</StyledTableCell>
                                    <StyledTableCell>{
                                        row.status_id === EmployeeStatus.Active ? 'Active' : 'Terminated'
                                    }</StyledTableCell>
                                </StyledTableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            </Stack>
        </Box>
    );
}
export default EmployeeSearch;